import { Meta } from '@master/model/common/Meta'

export class NextOfKinDetailsMeta extends Meta {
  name = ''
  relationship = ''
  contactNumber = ''
}
